function __rspack_empty_context(req) {
  var e = new Error("Cannot find module '" + req + "'");
  e.code = 'MODULE_NOT_FOUND';
  throw e;
}
__rspack_empty_context.keys = () => ([]);
__rspack_empty_context.resolve = __rspack_empty_context;
__rspack_empty_context.id = 93445;
module.exports = __rspack_empty_context;
